// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";
import { DEFAULT_VALUES } from "@libraries/web-framework";
import { FormattedMessage, useIntl } from "react-intl";

import { media, UNSAFE_media } from "@atlaskit/primitives/responsive";

import { ContentBlock } from "@/components/wpl/content-block/src";

const integrationStyles = css`
    align-items: center;
    display: flex;
    justify-content: center;
    padding: 192px 0;
    background-color: #ffffff;

    ${UNSAFE_media.below.xs} {
        background-image: url("https://wac-cdn.atlassian.com/dam/jcr:4edf08c6-db6f-415f-b5b0-58307b033bfa/integrations-upper-320.svg?cdnVersion=1194"),
            url("https://wac-cdn.atlassian.com/dam/jcr:c2559fbc-9186-4d97-91d8-9874220f5bce/integrations-lower-320.svg?cdnVersion=1194");
        background-position: center top, center bottom;
        background-repeat: no-repeat, no-repeat;
        background-size: 70%, 65%;
        flex-direction: column;
        padding: 142px 0;
    }
    ${UNSAFE_media.only.xs} {
        background-image: url("https://wac-cdn.atlassian.com/dam/jcr:4edf08c6-db6f-415f-b5b0-58307b033bfa/integrations-upper-320.svg?cdnVersion=1194"),
            url("https://wac-cdn.atlassian.com/dam/jcr:c2559fbc-9186-4d97-91d8-9874220f5bce/integrations-lower-320.svg?cdnVersion=1194");
        background-position: center top, center bottom;
        background-repeat: no-repeat, no-repeat;
        background-size: 350px, 350px;
        flex-direction: column;
    }
    ${UNSAFE_media.only.sm} {
        background-image: url("https://wac-cdn.atlassian.com/dam/jcr:557ec237-312c-4945-9e96-9bb54e5fe954/integrations-left-720.svg?cdnVersion=1194"),
            url("https://wac-cdn.atlassian.com/dam/jcr:7ee516f1-496a-43ec-a580-0fb6d22f2f2a/integrations-right-720.svg?cdnVersion=1194");
        background-position: left top 40px, right top 20px;
        background-repeat: no-repeat, no-repeat;
        background-size: 27% auto, 27% auto;
        padding: 96px 0;
    }
    ${UNSAFE_media.only.md} {
        background-image: url("https://wac-cdn.atlassian.com/dam/jcr:c62a1ec8-3eab-4bbd-ac12-dac4765e7178/integrations-left.svg?cdnVersion=1194"),
            url("https://wac-cdn.atlassian.com/dam/jcr:c14f553e-2abe-4b1e-90e6-2fbf013fdb0a/integrations-right.svg?cdnVersion=1194");
        background-position: left top 40px, right top 50px;
        background-repeat: no-repeat, no-repeat;
        background-size: 27% auto, 27% auto;
        padding: 96px 0;
    }
    ${media.above.lg} {
        background-image: url("https://wac-cdn.atlassian.com/dam/jcr:c62a1ec8-3eab-4bbd-ac12-dac4765e7178/integrations-left.svg?cdnVersion=1194"),
            url("https://wac-cdn.atlassian.com/dam/jcr:c14f553e-2abe-4b1e-90e6-2fbf013fdb0a/integrations-right.svg?cdnVersion=1194");
        background-position: left center, right top 30px;
        background-repeat: no-repeat, no-repeat;
        background-size: auto, auto;
    }

    .integrations-content {
        max-width: 720px;
        padding: 16px;
        width: 50%;

        ${media.above.xs} {
            h2 {
                font-size: 2.25rem;
            }
            p {
                font-size: 1rem;
            }
        }

        ${media.above.sm} {
            h2 {
                margin-bottom: 24px;
            }
        }

        ${UNSAFE_media.below.sm} {
            max-width: 1440px;
            width: 100%;

            h2 {
                font-size: 1.5rem;
                line-height: 1.33333333;
            }
        }

        h2,
        p,
        a {
            webkit-font-smoothing: antialiased;
            moz-osx-font-smoothing: grayscale;
        }

        h2 {
            color: #253858;
            margin-bottom: 14px;
            font-weight: 500;
        }
        p {
            color: #091e42;
            margin-bottom: 24px;
            font-weight: normal;
        }
        a {
            margin: 0px;
            padding: 4px 10px;
            font-weight: 500;
            height: unset;
        }
    }
`;

const IntegrationSection = () => {
    const intl = useIntl();

    return (
        <section css={integrationStyles}>
            <div className="integrations-content">
                <ContentBlock
                    headerText={intl.formatMessage({
                        id: "JiraSoftwarePageTemplate.integrationSection.header",
                        defaultMessage: "We believe in open relationships"
                    })}
                    bodyText={
                        <FormattedMessage
                            id="JiraSoftwarePageTemplate.integrationSection.body"
                            defaultMessage="If your team uses it, we integrate with it. Easily add your tools from the Atlassian Marketplace, keeping Jira as your central source of truth."
                            values={DEFAULT_VALUES}
                        />
                    }
                    headerType="h2"
                    isCentered
                    orientation="vertical"
                    ctaProps={{
                        buttonProps: {
                            text: intl.formatMessage({
                                id: "JiraSoftwarePageTemplate.integrationSection.cta",
                                defaultMessage: "Explore integrations"
                            }),
                            url: "https://marketplace.atlassian.com/",
                            type: "secondary",
                            size: "small",
                            dataEventProps: {
                                "data-event-component": "linkButton",
                                "data-event-container": "integrationSection",
                                "data-event": "clicked",
                                "data-product-key": "jiraSoftware"
                            }
                        }
                    }}
                />
            </div>
        </section>
    );
};

export default IntegrationSection;
